export default "__VITE_ASSET__DXyuOwDo__"